import { jsPDF } from "jspdf";

const generateNavtexPdf = (data,type) => {
    console.log(data,"data testing----")
  const doc = new jsPDF();

  // Decode HTML entities
  function decodeHtmlEntities(text) {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  }

  // Strip all HTML tags
  function stripHtmlTags(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  let y = 10;

    // Title
  const title = data.identifier && type
    ? `${type === "navTax"
        ? "NAVTEX"
        : type === "navArea"
          ? "NAVAREA"
          : "T & P Notice"} ${data.identifier}`
    : "NAVTEX NOTICE";
  
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(title, 105, y, { align: "center" });
  y += 10;

  const infoFields = [
    { label: "Date", key: "date" },
    { label: "Identifier", key: "identifier" },
    { label: "Type", key: "types" },
    { label: "B Chart", key: "b_char" },
    { label: "Station", key: "station" },
    { label: "Place", key: "place" },
    { label: "General Area", key: "general_area" },
  ];

  const leftColX = 15;
  const valueX = 60;

  doc.setFontSize(11);

  infoFields.forEach((field) => {
    const value = data[field.key];
    if (value != null && value !== "") {
      doc.setFont("helvetica", "bold");
      doc.text(`${field.label}`, leftColX, y);

      const textWidthLimit = 130;
      const contentLines = doc.splitTextToSize(value.toString(), textWidthLimit);
      doc.setFont("helvetica", "normal");
      doc.text(contentLines, valueX, y);

      y += contentLines.length * 6;
    }
  });

  // Message
    if (data.message) {
      y += 4;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.text("Message:", leftColX, y);
      y += 8;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);

      // Step 1: Decode HTML entities
      let cleanText = decodeHtmlEntities(data.message);

      // Step 2: Strip HTML tags
      cleanText = stripHtmlTags(cleanText);

      // Step 3: Add line breaks before numbered points followed by capital letter
      cleanText = cleanText.replace(/(\d+\.\s)(?=[A-Z])/g, "\n$1");

      // Step 4: Split and wrap
      const lines = cleanText.split("\n").flatMap((line) =>
        doc.splitTextToSize(line.trim(), 180)
      );

      // Step 5: Print
      lines.forEach((line) => {
        doc.text(line, leftColX, y);
        y += 6;
      });
    }

  // Open in new tab
  const blob = doc.output("blob");
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank");
};

export default generateNavtexPdf;
